
export default function Process() {
  const steps = [
    {
      number: '01',
      icon: 'ri-message-3-line',
      title: 'Primeiro Contato',
      description: 'Entre em contato via WhatsApp ou formulário. Farei uma análise inicial da sua situação e agendaremos uma consulta.'
    },
    {
      number: '02',
      icon: 'ri-file-search-line',
      title: 'Análise do Caso',
      description: 'Reunião para entender todos os detalhes da sua situação. Análise de documentos, contratos e evidências disponíveis.'
    },
    {
      number: '03',
      icon: 'ri-lightbulb-line',
      title: 'Orientação Jurídica',
      description: 'Explicação clara sobre seus direitos, possibilidades jurídicas e estratégias disponíveis para o seu caso específico.'
    },
    {
      number: '04',
      icon: 'ri-file-list-3-line',
      title: 'Planejamento',
      description: 'Definição da melhor estratégia jurídica, prazos, documentação necessária e próximos passos do processo.'
    },
    {
      number: '05',
      icon: 'ri-scales-3-line',
      title: 'Atuação Jurídica',
      description: 'Execução das medidas judiciais ou extrajudiciais necessárias para a defesa dos seus direitos trabalhistas.'
    },
    {
      number: '06',
      icon: 'ri-chat-follow-up-line',
      title: 'Acompanhamento',
      description: 'Você será mantido informado sobre todas as etapas do processo, com comunicação transparente e acessível.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Como Funciona o Atendimento
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Um processo transparente e organizado para garantir que você compreenda cada etapa da defesa dos seus direitos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border-2 border-gray-200 hover:border-[#C9A961] transition-all duration-300 group"
            >
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-gradient-to-br from-[#4A1C40] to-[#5A2C50] rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                <span className="text-[#C9A961] font-bold text-xl" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  {step.number}
                </span>
              </div>

              <div className="mt-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#C9A961]/10 rounded-lg mb-4">
                  <i className={`${step.icon} text-3xl text-[#4A1C40]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A1C40] mb-3" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  {step.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#C9A961]/10 to-[#4A1C40]/10 rounded-2xl p-10 border-2 border-[#C9A961]/30">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-24 h-24 flex items-center justify-center bg-gradient-to-br from-[#4A1C40] to-[#5A2C50] rounded-full">
                <i className="ri-time-line text-4xl text-[#C9A961]"></i>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-[#4A1C40] mb-3" style={{ fontFamily: 'Crimson Pro, serif' }}>
                Atendimento Personalizado
              </h3>
              <p className="text-gray-700 leading-relaxed text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                Cada caso é único e merece atenção individualizada. O tempo de duração de um processo trabalhista
                varia conforme a complexidade da situação, a comarca e outros fatores. Durante todo o processo,
                você receberá orientação clara e acompanhamento próximo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
